import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var userListRes;
export const userListTodo = createAsyncThunk('userList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/get_user_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "role_code": val.role,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return userListRes = res.data
    } catch (error) {
        return userListRes = error.response.data
    }
})


const userListSlice = createSlice({
    name: 'userList',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(userListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('userList', state.data)
            }
        });
        builder.addCase(userListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default userListSlice.reducer; 